// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as TailwindMerge from "tailwind-merge";
import Wf_logoSvg from "./assets/wf_logo.svg";
import * as Spinner$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Spinner.res.mjs";
import * as WordFlyersJourneys$LiteracyplanetClientSxEntry from "./WordFlyersJourneys.res.mjs";
import * as WordFlyersTrophies$LiteracyplanetClientSxEntry from "./assets/WordFlyersTrophies.res.mjs";
import * as WordFlyersIndexQuery$LiteracyplanetClientSxEntry from "./WordFlyersIndexQuery.res.mjs";

var logoIcon = Wf_logoSvg;

function WordFlyersIndexContainer$JourneyTabs(props) {
  var onMenuClick = props.onMenuClick;
  var pageToUrl = props.pageToUrl;
  var makePage = props.makePage;
  var journey = props.journey;
  return React.createElement("ul", {
              className: "flex items-end gap-2 leading-none"
            }, Belt_Array.map(props.journeys, (function (j) {
                    var page = Curry._2(makePage, j.id, "1");
                    return React.createElement("li", {
                                key: j.id,
                                "aria-selected": journey === j.id,
                                className: "group rounded-t-[4px] bg-[#ffdbb6] text-[#a27c62] aria-selected:bg-[#ffefd7] aria-selected:text-[#6e4029] aria-[selected=false]:bg-gradient-to-t aria-[selected=false]:from-[#f4d5b7] aria-[selected=false]:to-[#ffefd7] aria-[selected=false]:to-20% "
                              }, React.createElement("a", {
                                    className: "block h-full w-full py-2 pl-4 pr-8 font-black group-aria-selected:py-3",
                                    href: Curry._1(pageToUrl, page),
                                    onClick: Curry._1(onMenuClick, page)
                                  }, j.title));
                  })));
}

var JourneyTabs = {
  make: WordFlyersIndexContainer$JourneyTabs
};

function WordFlyersIndexContainer$ActivityButton(props) {
  var activity = props.activity;
  var partial = activity.result.started;
  var match = activity.result.bestResponsesScore;
  var bgCss = partial ? "bg-lpgray-400" : (
      match !== undefined ? (
          match < 70 ? "bg-[#f65640] border-[#b63b2a]" : "bg-[#46b800] border-[#389200]"
        ) : ""
    );
  var score = activity.result.bestResponsesScore;
  return React.createElement("a", {
              className: TailwindMerge.twMerge("relative block h-8 w-14 cursor-pointer overflow-clip border border-slate-400 bg-[#4497b5] font-black text-white transition-transform duration-75 [-webkit-text-stroke:1px_rgb(0_0_0_/_.75)] hover:scale-105 focus:border-lpblue-700 focus:outline-none focus-visible:ring-1 focus-visible:ring-lpblue-700", "after:absolute after:left-1/2 after:top-[42%] after:z-[1] after:-ml-[--radial-offset] after:h-[--radial-size] after:w-[--radial-size] after:rounded-full after:bg-contain after:content-[''] after:[background-image:var(--bg-radial)]", bgCss),
              style: Object.assign({}, {}, {
                    "--bg-radial": "radial-gradient(rgb(255 255 255 / .5), transparent)",
                    "--radial-size": "200px",
                    "--radial-offset": "calc(var(--radial-size) / 2)"
                  }),
              title: activity.title + " lesseon for " + props.unit,
              href: props.href,
              onClick: props.onPlayActivity
            }, React.createElement("div", {
                  className: "flex h-full w-full items-center justify-center px-1.5 py-0.5"
                }, score !== undefined ? (
                    props.trophyView ? React.createElement("div", {
                            className: "w-7 z-10"
                          }, React.createElement(WordFlyersTrophies$LiteracyplanetClientSxEntry.Gold.make, {})) : React.createElement("div", {
                            className: "text-lg"
                          }, score.toString() + "%")
                  ) : null, React.createElement("span", {
                      className: "hidden"
                    }, activity.title)));
}

var ActivityButton = {
  make: WordFlyersIndexContainer$ActivityButton
};

function WordFlyersIndexContainer$GateTabs(props) {
  var onMenuClick = props.onMenuClick;
  var pageToUrl = props.pageToUrl;
  var journey = props.journey;
  var makePage = props.makePage;
  var gate = props.gate;
  return React.createElement("ul", {
              className: "flex items-end gap-2 leading-none"
            }, Belt_Array.mapWithIndex(props.gates, (function (idx, g) {
                    return Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(g.title.split("/").pop()), null, (function (title) {
                                  var page = Curry._2(makePage, Caml_option.some(journey), String(idx));
                                  return React.createElement("li", {
                                              key: g.id,
                                              "aria-selected": idx.toString() === gate,
                                              className: "group relative rounded-t-[4px] border-[#f0f1f3] text-[#5494ac] shadow-md  shadow-black/20 after:absolute after:bottom-[-1px] after:z-[1] after:block after:w-full after:border-white after:content-[''] aria-selected:bg-white aria-selected:text-[#405067] aria-selected:after:border-b aria-[selected=false]:bg-gradient-to-t aria-[selected=false]:from-[#edf1f1] aria-[selected=false]:to-white aria-[selected=false]:to-20%"
                                            }, React.createElement("a", {
                                                  className: "block h-full w-full px-4 py-3 font-black group-aria-selected:py-4",
                                                  href: Curry._1(pageToUrl, page),
                                                  onClick: Curry._1(onMenuClick, page)
                                                }, title));
                                }));
                  })));
}

var GateTabs = {
  make: WordFlyersIndexContainer$GateTabs
};

function WordFlyersIndexContainer$LessonTypePanel(props) {
  return React.createElement("div", {
              className: "mr-2 flex flex-col justify-center gap-1.5 border border-[#c1e1ea]"
            }, React.createElement("div", {
                  className: "h-8 bg-[#c6e3eb] px-3 pt-1 text-center font-bold uppercase text-[#506682]"
                }, "Arrivals/Departures"), Belt_Array.map(props.unit.activities, (function (u) {
                    return React.createElement("div", {
                                className: "relative h-8 px-3 pr-10 pt-1 text-[#5494ac] after:absolute after:bottom-[-0.1875rem] after:left-[2.5%] after:z-[1] after:block after:w-[95%] after:border-b after:border-[#c1e1ea]/50 after:content-[''] after:last:border-transparent"
                              }, u.title);
                  })));
}

var LessonTypePanel = {
  make: WordFlyersIndexContainer$LessonTypePanel
};

function WordFlyersIndexContainer$EmptyGrid(props) {
  return React.createElement("div", {
              className: "flex gap-2 p-2"
            });
}

var EmptyGrid = {
  make: WordFlyersIndexContainer$EmptyGrid
};

function WordFlyersIndexContainer$Grid(props) {
  var trophyView = props.trophyView;
  var onMenuClick = props.onMenuClick;
  var pageToUrl = props.pageToUrl;
  var makeActivity = props.makeActivity;
  var units = props.units;
  return React.createElement("div", {
              className: "flex gap-2 p-2"
            }, Belt_Option.mapWithDefault(Belt_Array.get(units, 0), null, (function (unit_) {
                    return React.createElement(WordFlyersIndexContainer$LessonTypePanel, {
                                unit: unit_
                              });
                  })), Belt_Array.mapWithIndex(units, (function (idx, param) {
                    var unit_ = param.unit;
                    return React.createElement("ul", {
                                key: unit_.id,
                                className: "flex flex-col gap-1.5"
                              }, React.createElement("li", {
                                    className: " leading-[0] "
                                  }, React.createElement("a", {
                                        className: TailwindMerge.twMerge("relative inline-block h-8 w-14 cursor-pointer overflow-clip bg-[#9e62a1] text-white", "after:absolute after:left-1/2 after:top-[42%] after:z-[1] after:-ml-[--radial-offset] after:h-[--radial-size] after:w-[--radial-size] after:rounded-full after:bg-contain after:content-[''] after:[background-image:var(--bg-radial)]"),
                                        style: Object.assign({}, {}, {
                                              "--bg-radial": "radial-gradient(rgb(255 255 255 / .5), transparent)",
                                              "--radial-size": "200px",
                                              "--radial-offset": "calc(var(--radial-size) / 2)"
                                            }),
                                        title: unit_.title
                                      }, idx === 0 ? React.createElement("div", {
                                              className: "pl-1 text-xs"
                                            }, "Unit") : null, React.createElement("div", {
                                            className: "absolute bottom-1 right-1.5 font-bold leading-none"
                                          }, (idx + 1 | 0).toString()))), Belt_Array.map(param.activities, (function (activity) {
                                      var activityPage = Curry._1(makeActivity, activity.id);
                                      var href = Curry._1(pageToUrl, activityPage);
                                      var onPlayActivity = function (evt) {
                                        Curry._2(onMenuClick, activityPage, evt);
                                      };
                                      return React.createElement("li", {
                                                  key: activity.id
                                                }, React.createElement(WordFlyersIndexContainer$ActivityButton, {
                                                      unit: unit_.title,
                                                      activity: activity,
                                                      href: href,
                                                      onPlayActivity: onPlayActivity,
                                                      trophyView: trophyView
                                                    }));
                                    })));
                  })));
}

var Grid = {
  make: WordFlyersIndexContainer$Grid
};

function WordFlyersIndexContainer(props) {
  var pageToUrl = props.pageToUrl;
  var makePage = props.makePage;
  var optionalGate = props.optionalGate;
  var redirect = props.redirect;
  var journey = WordFlyersJourneys$LiteracyplanetClientSxEntry.journeyId(props.optionalJourney);
  var match = React.useState(function (param) {
        
      });
  var setData = match[1];
  var data = match[0];
  var useIndex = WordFlyersIndexQuery$LiteracyplanetClientSxEntry.use();
  var onMenuClick = function (page, evt) {
    var keysPressed = [
      evt.metaKey,
      evt.altKey,
      evt.ctrlKey,
      evt.shiftKey
    ];
    var match = keysPressed.some(function (b) {
          return b === true;
        });
    if (match) {
      return ;
    } else {
      evt.preventDefault();
      return Curry._1(redirect, page);
    }
  };
  var match$1 = React.useState(function (param) {
        return true;
      });
  var setView = match$1[1];
  var toggleView = function (param) {
    Curry._1(setView, (function (x) {
            return !x;
          }));
  };
  React.useEffect((function (param) {
          var r = document.querySelector(":root");
          r.style.setProperty("--html-font-size", "18px");
          return (function (param) {
                    r.removeAttribute("style");
                  });
        }), []);
  React.useEffect((function (param) {
          var fetchIndex = async function (param) {
            var res = await Curry._2(useIndex, journey, optionalGate);
            return Curry._1(setData, (function (param) {
                          return res;
                        }));
          };
          fetchIndex();
        }), [
        journey,
        optionalGate
      ]);
  var tmp;
  if (data !== undefined) {
    var gate = data.gate;
    tmp = React.createElement(React.Fragment, {}, React.createElement("nav", {
              className: "flex justify-between"
            }, React.createElement(WordFlyersIndexContainer$GateTabs, {
                  gates: data.gates,
                  gate: gate,
                  makePage: makePage,
                  journey: journey,
                  pageToUrl: pageToUrl,
                  onMenuClick: onMenuClick
                }), React.createElement("div", undefined, React.createElement("div", {
                      className: "cursor-pointer text-sm text-lpblue-600 hover:text-lpblue-700 focus-visible:text-lpblue-600",
                      tabIndex: 0,
                      onKeyPress: toggleView,
                      onClick: toggleView
                    }, "Toggle Results"))), React.createElement("section", {
              className: "relative w-full border border-[#f0f1f3] bg-white shadow-md shadow-black/20"
            }, React.createElement(WordFlyersIndexContainer$Grid, {
                  units: data.units,
                  makeActivity: Curry._2(props.makeActivity, journey, gate),
                  pageToUrl: pageToUrl,
                  onMenuClick: onMenuClick,
                  trophyView: match$1[0]
                })));
  } else {
    tmp = React.createElement("div", {
          className: "h-24 w-full pt-5"
        }, React.createElement(Spinner$LiteracyplanetClientFlags.make, {}));
  }
  return React.createElement("div", undefined, React.createElement("a", {
                  className: "inline-block rounded-r-full border-b border-r border-[#f0f1f3] bg-[#ffefd7] py-1.5 pl-2 pr-3 font-sans shadow-md",
                  title: "Go Back to Missions",
                  href: "#",
                  onClick: props.onBack
                }, React.createElement("svg", {
                      className: "w-6 fill-[#5494ac]",
                      id: "meteor-icon-kit__regular-chevron-left-xs",
                      viewBox: "-2 0 10 10",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          clipRule: "evenodd",
                          d: "M5.7071 8.2929C6.0976 8.6834 6.0976 9.3166 5.7071 9.7071C5.3166 10.0976 4.6834 10.0976 4.2929 9.7071L0.29289 5.7071C-0.09763 5.3166 -0.09763 4.6834 0.29289 4.2929L4.2929 0.29289C4.6834 -0.09763 5.3166 -0.09763 5.7071 0.29289C6.0976 0.68342 6.0976 1.31658 5.7071 1.70711L2.4142 5L5.7071 8.2929z",
                          fillRule: "evenodd"
                        }))), React.createElement("div", {
                  className: "m-auto grid justify-center font-sans"
                }, React.createElement("img", {
                      className: "w-20",
                      title: "Word Flyers Logo",
                      src: logoIcon
                    }), React.createElement("div", {
                      className: "min-w-[51rem]"
                    }, React.createElement("header", undefined, React.createElement(WordFlyersIndexContainer$JourneyTabs, {
                              journeys: WordFlyersJourneys$LiteracyplanetClientSxEntry.t,
                              journey: journey,
                              makePage: makePage,
                              pageToUrl: pageToUrl,
                              onMenuClick: onMenuClick
                            })), React.createElement("div", {
                          className: "grid rounded-tr-lg bg-[#ffefd7] p-3"
                        }, tmp))));
}

var make = WordFlyersIndexContainer;

export {
  logoIcon ,
  JourneyTabs ,
  ActivityButton ,
  GateTabs ,
  LessonTypePanel ,
  EmptyGrid ,
  Grid ,
  make ,
}
/* logoIcon Not a pure module */
